import React from "react";
import { useMsal } from "@azure/msal-react";
import { ArrowRightOnRectangleIcon } from "@heroicons/react/24/outline";
import { clearAuthData } from "../Api/index.ts";
// import DropdownButton from "react-bootstrap/DropdownButton";
// import Dropdown from "react-bootstrap/Dropdown";


// /**
//  * Renders a sign-out button
//  */
export const SignOutButton = () => {
    const { instance } = useMsal();

    const handleLogout = () => {
        const account = instance.getActiveAccount();
        const config = instance.getConfiguration();
        const authority = config.auth?.authority;
        // Capture UPN before clearing local state
        const upn = account?.username || sessionStorage.getItem("entra_email") || undefined;
        // Resolve post-logout redirect uri from config or default to '/'
        let postLogout = config.auth?.postLogoutRedirectUri;
        postLogout = typeof postLogout === 'function' ? postLogout() : (postLogout || '/');

        // Clear app session data (do NOT clear MSAL cache here)
        clearAuthData();

    // Use redirect with account + logoutHint + tenant authority to suppress account picker
    instance.logoutRedirect({
            account,
            logoutHint: upn,
            postLogoutRedirectUri: postLogout,
            authority,
        });
    // If your tenant still shows a picker due to multiple AAD sessions, consider a hard redirect:
    // const idTokenHint = sessionStorage.getItem('entra_id_token');
    // const url = new URL((authority || '').replace(/\/$/, '') + '/oauth2/v2.0/logout');
    // url.searchParams.set('post_logout_redirect_uri', postLogout);
    // if (upn) url.searchParams.set('logout_hint', upn);
    // if (idTokenHint) url.searchParams.set('id_token_hint', idTokenHint);
    // window.location.assign(url.toString());
    }

    
    return (
        // <DropdownButton variant="secondary" className="ml-auto" drop="start" title="Sign Out">
        //     <Dropdown.Item as="button" onClick={() => handleLogout("popup")}>Sign out using Popup</Dropdown.Item>
        //     <Dropdown.Item as="button" onClick={() => handleLogout("redirect")}>Sign out using Redirect</Dropdown.Item>
        // </DropdownButton>
        
    <button onClick={handleLogout}
            className="flex items-center gap-2 w-full px-2 py-2 mb-2 text-red-600 hover:bg-gray-100 text-left"
        >
        <ArrowRightOnRectangleIcon className="w-5 h-5" />
        Log out
        </button>
    )
}
